import React from 'react';
import {
  Avatar,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import ChevronDownIcon from '@mui/icons-material/ExpandMore';
import User from '../../assets/icons/User';
import {
  buttonStyles,
  avatarStyles,
  nameTextStyles,
  mainBoxStyles,
  MenuDropdownStyles,
} from './UserMenuProps';
import LogOutIcon from '../../assets/icons/LogOutIcon';
import LockIcon from '../../assets/icons/LockIcon';
import { useAuth } from '../../store/authAtom';
import { useTabNavigation } from '../../store/mainTabsStore';

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { authState, logout } = useAuth();
  const { removeAllTabs } = useTabNavigation();

  const close = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    close();
  };

  async function handleLogout() {
    close();
    await logout();
    removeAllTabs();
  }

  return (
    <Box data-testid="user-menu" sx={mainBoxStyles}>
      <Button onClick={handleClick} sx={buttonStyles}>
        <Avatar sx={avatarStyles}>
          <User />
        </Avatar>

        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography fontSize={12} color="common.white">
            Welcome,
          </Typography>
          <Typography sx={nameTextStyles}>
            {authState.user?.fullName}
          </Typography>
        </Box>

        <ChevronDownIcon
          sx={{
            transform: anchorEl !== null ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: '.2s ease',
          }}
        />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ marginTop: '5px' }}
      >
        <MenuItem onClick={() => handleClose()} sx={MenuDropdownStyles}>
          <ListItemIcon sx={{ marginRight: '-8px' }}>
            <LockIcon />
          </ListItemIcon>
          <ListItemText primary="Change Password" />
        </MenuItem>
        <MenuItem onClick={() => handleLogout()}>
          <ListItemIcon sx={{ marginRight: '-8px' }}>
            <LogOutIcon />
          </ListItemIcon>
          <ListItemText primary="Log Out" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
